import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addExperience,
  updateCandidateExperience,
} from "./ExperienceAPI2";
// import { fetchSkills } from './candidateProfileAPI';

const initialState = {
  value: 0,
  status: "idle",
  experience: {},
};

export const addExperienceAsync = createAsyncThunk(
  "candidateProfile/experience",
  async (info) => {
    // console.log("Info:- ", info);
    const data = await addExperience(info);
    console.log("data:", data);
    return data;
  }
);

export const updateCandidateExperienceAsync = createAsyncThunk(
  "candidateExperience/update",
  async ({ uuid, CandidateExperienceData }, { rejectWithValue }) => {
    try {
      const response = await updateCandidateExperience(
        uuid,
        CandidateExperienceData
      );
      console.log("Response Slice", response);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const candExperienceSlise2 = createSlice({
  name: "fetchJob",
  initialState,
  extraReducers: (builder) => {
    builder


      .addCase(addExperienceAsync.pending, (state) => {
        state.status = "pending";
      })
      .addCase(addExperienceAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.experience = action.payload.msg;
        // console.log("action.payload: ", action.payload.msg);
        // console.log("fetched experience data:- ", state.experience);
      })

      .addCase(updateCandidateExperienceAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCandidateExperienceAsync.fulfilled, (state, action) => {
        state.loading = false;

        if (Array.isArray(state.data)) {
          const updatedCandidateIndex = state.data.findIndex(
            (CandidateExperienceData) =>
                CandidateExperienceData.id === action.payload.id
          );

          if (updatedCandidateIndex !== -1) {
            state.data[updatedCandidateIndex] = action.payload;
          }
        } else {
          state.data = [action.payload]; // Fallback: set the state to an array with the 
        }
      })

      .addCase(updateCandidateExperienceAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update education";
      });
  },
});

export const selectStatus = (state) => state.candProfileExperiences.status;
export const selectExperienceResponse = (state) =>
  state.candProfileExperiences.experience;
export default candExperienceSlise2.reducer;
